                                                
import React, { createContext, useContext, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';

// 1. Cria o Contexto
const AuthContext = createContext(null);

// 2. Cria o Provedor (o componente que vai gerenciar o estado)
export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const tokenFromUrl = urlParams.get('token');

        let effectiveToken = null;

        if (tokenFromUrl) {
            // Se houver um token na URL, ele tem prioridade máxima.
            localStorage.setItem('token', tokenFromUrl);
            effectiveToken = tokenFromUrl;
            // Limpa o token da URL para não ficar visível e evitar problemas no refresh
            window.history.replaceState({}, document.title, window.location.pathname);
        } else {
            // Se não, tenta obter o token que já estava guardado.
            effectiveToken = localStorage.getItem('token');
        }

        if (effectiveToken) {
            try {
                const decodedToken = jwtDecode(effectiveToken);
                // Verifica se o token expirou
                if (decodedToken.exp * 1000 < Date.now()) {
                    // Token expirado
                    localStorage.removeItem('token');
setToken(null);
                    setUser(null);
                } else {
                    // Token válido
                    setToken(effectiveToken);
                    setUser({ 
                        name: decodedToken.name, 
                        role: decodedToken.role, 
                        avatarUrl: decodedToken.avatarUrl 
                    });
                }
            } catch (error) {
                // Token inválido ou malformado
                console.error("Erro ao decodificar token:", error);
                localStorage.removeItem('token');
                setToken(null);
                setUser(null);
            }
        }
        // Finaliza o carregamento inicial
        setLoading(false);

    }, []); // O array vazio [] garante que esta lógica só corre uma vez, quando a app carrega.

    const logout = () => {
        localStorage.removeItem('token');
        setUser(null);
        setToken(null);
        window.location.href = `${process.env.REACT_APP_COCKPIT_URL}/logout`;
    };

    const value = { user, token, logout, loading };

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};

// 3. Cria o Hook customizado para consumir o contexto facilmente
export const useAuth = () => {
    return useContext(AuthContext);
};